module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.tournament && _vm.tournament.matches && _vm.tournament.matches.length > 0) ? _c('div', [_c('md-list', [_c('md-list-item', {
    attrs: {
      "md-expand": ""
    }
  }, [_c('md-icon', [_vm._v("filter_list")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Options")]), _vm._v(" "), _c('md-list', {
    staticClass: "flex-container",
    attrs: {
      "slot": "md-expand"
    },
    slot: "md-expand"
  }, [_c('md-list-item', {
    staticClass: "md-inset flex-item"
  }, [_c('md-switch', {
    model: {
      value: (_vm.showCompleted),
      callback: function($$v) {
        _vm.showCompleted = $$v
      },
      expression: "showCompleted"
    }
  }, [_vm._v("Completed matches")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset flex-item"
  }, [_c('md-switch', {
    model: {
      value: (_vm.showInProgress),
      callback: function($$v) {
        _vm.showInProgress = $$v
      },
      expression: "showInProgress"
    }
  }, [_vm._v("In-progress matches")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset flex-item"
  }, [_c('md-switch', {
    model: {
      value: (_vm.showReady),
      callback: function($$v) {
        _vm.showReady = $$v
      },
      expression: "showReady"
    }
  }, [_vm._v("Ready-to-start matches")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset flex-item"
  }, [_c('md-switch', {
    model: {
      value: (_vm.showPending),
      callback: function($$v) {
        _vm.showPending = $$v
      },
      expression: "showPending"
    }
  }, [_vm._v("Pending matches")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-container"
  }, [(_vm.showCompleted) ? _c('MatchList', {
    staticClass: "flex-item",
    attrs: {
      "title": "Completed",
      "matches": _vm.completedMatches,
      "tournament": _vm.tournament
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showInProgress) ? _c('MatchList', {
    staticClass: "flex-item",
    attrs: {
      "title": "In-progress",
      "matches": _vm.inProgressMatches,
      "tournament": _vm.tournament
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showReady) ? _c('MatchList', {
    staticClass: "flex-item",
    attrs: {
      "title": "Ready-to-start",
      "matches": _vm.readyMatches,
      "tournament": _vm.tournament
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPending) ? _c('MatchList', {
    staticClass: "flex-item",
    attrs: {
      "title": "Pending",
      "matches": _vm.pendingMatches,
      "tournament": _vm.tournament
    }
  }) : _vm._e()], 1)], 1) : _c('div', [_c('md-empty-state', {
    attrs: {
      "md-icon": "remove_circle",
      "md-label": "There are currently no matches for this tournament"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c48a0c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tournamentComponents/tournamentMatches.vue
// module id = 440
// module chunks = 1